import http from '@/http'
import createCrudModule from 'vuex-crud'
import departments from './departments'
import { withDataFilter } from '@/store/index'

let module = createCrudModule({
  client: http,
  resource: 'admin/offices',
  urlRoot: 'admin/offices',

  state: {
    total: 0
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  }
})

export default {
  ...withDataFilter(module),
  modules: {
    departments
  }
}
